var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showAlert)?_c('b-alert',{staticClass:"bumble-alert",attrs:{"variant":_vm.alertType,"show":""}},[_vm._v(_vm._s(_vm.message))]):_vm._e(),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }